import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {
  Box,
  Collapse,
  Drawer as MUIDrawer,
  Menu,
  AppBar,
  ClickAwayListener,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
  Button,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// iconos
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import AuditorIcon from '@material-ui/icons/VerifiedUser';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ControlIcon from '@material-ui/icons/ControlCamera';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import HomeIcon from '@mui/icons-material/Home';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import MenuIcon from '@material-ui/icons/Menu';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';
import UserContext from '../../context/UserContext';
import { getTokenFromLocalStorage } from '../../services/auth';
import { getDashboards } from '../../services/dashboard';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import AddIcon from '@material-ui/icons/Add';
// Custom Hooks
import useDeviceDetect from "../../hooks/useDeviceDetect";
import { subscription } from '../../service_worker/helpers';
import NotificationIconComponent from '../NotificationIconComponent/NotificationIconComponent';
//png
import logoAvatar from '../common/avatar_logo.png';
import logoAssistantWhite from '../common/assistant_logo_white.png';
import logoAssistantBlue from '../common/assistant_logo_blue.png';
//Helpers
import { blueBar } from '../../helpers/common'
// Components
import ContainerChips from './ContainerChips';

const drawerWidth = 270;
let scrollsSettings = {
  overflowY: "auto",
  maxHeight: "168px",
  overflowX: "hidden",
  background: "rgba(255,255,255,0.04)",
  marginRight: "2px",
  padding: "4px 0 2px 0",
  borderRadius: "10px",
}
let webkitScrollbar = {
  width: "4px"
}
let webkitscrollbarTrack = {
  background: "transparent",
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    //estilo agregado para q en la funcion windows.print() este componente nunca este en la imagen de el pdf.
    "@media print": {
      display: 'none'
    }
  },
  modalOverlay: {
    zIndex: 100,
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    backgroundColor: ' rgba(0, 0, 0, 0.6)',
  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    zIndex: theme.zIndex.drawer - 1,
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 0,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    background: 'linear-gradient(180deg, #63add5 0%, #5ca9d1 42%, #6ab3d8 100%)',
    color: theme.palette.common.white,
    boxShadow: '10px 0 30px rgba(9, 45, 67, 0.16)',
    borderRight: '1px solid rgba(255,255,255,0.16)',
    '& .MuiListItemIcon-root': {
      color: theme.palette.common.white,
    },
    '& .MuiListItem-root': {
      color: theme.palette.common.white,
    },
    '& $menuItem': {
      color: 'rgba(255,255,255,0.95)',
      margin: '3.2px 3.6px 3.2px 2.4px',
      boxShadow: '0 4px 12px rgba(10, 45, 68, 0.06)',
    },
    '& $menuItem:hover': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.11) 0%, rgba(255,255,255,0.05) 100%)',
      boxShadow: '0 8px 16px rgba(14, 52, 78, 0.1)',
      transform: 'translateY(-2px)',
      borderColor: 'rgba(255,255,255,0.12)',
    },
    '& $menuItem .MuiListItemIcon-root': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.065) 0%, rgba(255,255,255,0.025) 100%)',
      border: '1px solid rgba(255,255,255,0.045)',
      boxShadow: '0 6px 12px rgba(7, 32, 49, 0.08), inset 0 1px 0 rgba(255,255,255,0.05)',
    },
    '& $nested': {
      color: 'rgba(255,255,255,0.8)',
    },
    '& $nested:hover': {
      background: 'rgba(255,255,255,0.08)',
      transform: 'translateX(3px)',
      boxShadow: '0 8px 18px rgba(10, 45, 68, 0.08)',
    },
    '& $navLink[aria-current="page"] $menuItem': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.065) 100%)',
      boxShadow: '0 8px 18px rgba(10, 45, 68, 0.12)',
      borderColor: 'rgba(255,255,255,0.1)',
    },
    '& $menuItemActive': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.065) 100%)',
      boxShadow: '0 8px 18px rgba(10, 45, 68, 0.12)',
      borderColor: 'rgba(255,255,255,0.1)',
    },
    '& $navLink[aria-current="page"] $nested': {
      background: 'rgba(255,255,255,0.12)',
      color: '#fff',
      borderColor: 'rgba(255,255,255,0.12)',
    },
    '&::-webkit-scrollbar': {
      width: '0em',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
    },
    '&': {
      scrollbarWidth: 'none', // Firefox
      msOverflowStyle: 'none', // IE 10+
    },
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(8) + 1,
    background: 'linear-gradient(180deg, #f1f4f6 0%, #ebe8e8 52%, #e6ecef 100%)',
    boxShadow: '8px 0 24px rgba(12, 55, 84, 0.08)',
    borderRight: '1px solid rgba(37, 134, 188, 0.08)',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8) + 1,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& $menuItem': {
      width: 52,
      minWidth: 52,
      height: 52,
      minHeight: 52,
      margin: theme.spacing(0.45, 'auto'),
      padding: 0,
      justifyContent: 'center',
      border: '1px solid transparent',
      background: 'transparent',
      boxShadow: 'none',
    },
    '& $menuItem:hover': {
      background: 'linear-gradient(180deg, rgba(249, 252, 255, 0.94) 0%, rgba(237, 246, 251, 0.92) 100%)',
      boxShadow: '0 10px 18px rgba(8, 41, 63, 0.08)',
      transform: 'translateY(-1px)',
      borderColor: 'rgba(37, 134, 188, 0.12)',
    },
    '& $menuItem .MuiListItemIcon-root': {
      minWidth: 0,
      marginRight: 0,
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
    },
    '& $menuItem .MuiListItemText-root': {
      display: 'none',
    },
    '& $menuItem .MuiSvgIcon-root': {
      fontSize: '1.45rem',
    },
    '& $menuItem > .MuiSvgIcon-root': {
      display: 'none',
    },
    '& $navLink[aria-current="page"] $menuItem': {
      background: 'linear-gradient(180deg, rgba(220, 238, 248, 0.96) 0%, rgba(210, 232, 244, 0.94) 100%)',
      boxShadow: '0 10px 22px rgba(16, 73, 105, 0.11)',
      borderColor: 'rgba(37, 134, 188, 0.12)',
    },
    '& $menuItemActive': {
      background: 'linear-gradient(180deg, rgba(220, 238, 248, 0.96) 0%, rgba(210, 232, 244, 0.94) 100%)',
      boxShadow: '0 10px 22px rgba(16, 73, 105, 0.11)',
      borderColor: 'rgba(37, 134, 188, 0.12)',
    },
    '& $navLink[aria-current="page"] $menuItem .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& $menuItemActive .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  toolbar1: {
    minHeight: 52,
    paddingLeft: theme.spacing(1.1),
    paddingRight: theme.spacing(1.1),
    background: 'linear-gradient(180deg, rgba(249, 249, 249, 0.98) 0%, rgba(236, 245, 250, 0.98) 58%, rgba(247, 247, 247, 0.98) 100%)',
    boxShadow: '0 8px 18px rgba(12, 55, 84, 0.06)',
    borderBottom: '1px solid rgba(37, 134, 188, 0.08)',
    '& .MuiIconButton-root': {
      width: 38,
      height: 38,
      marginLeft: theme.spacing(0.7),
      padding: 0,
      borderRadius: 999,
      background: 'linear-gradient(180deg, rgba(243, 248, 251, 0.72) 0%, rgba(233, 241, 246, 0.64) 100%)',
      border: '1px solid rgba(37, 134, 188, 0.06)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.35)',
      transition: 'transform 180ms ease, box-shadow 180ms ease, background 180ms ease, border-color 180ms ease',
      '&:hover': {
        background: 'linear-gradient(180deg, rgba(250, 253, 255, 0.98) 0%, rgba(239, 247, 251, 0.96) 100%)',
        boxShadow: '0 10px 18px rgba(8, 41, 63, 0.08)',
        transform: 'translateY(-1px)',
        borderColor: 'rgba(37, 134, 188, 0.12)',
      },
    },
  },
  topActions: {
    position: 'fixed',
    right: theme.spacing(1),
    top: theme.spacing(0.9),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.15),
  },
  headerIconLink: {
    display: 'inline-flex',
    textDecoration: 'none',
  },
  paymentsButtonSquare: {
    borderRadius: `${theme.borderRadiusBoxes?.borderRadius || 4}px !important`,
  },
  headerLogo: {
    position: 'fixed',
    left: 75,
    height: '1.25em',
    '@media (max-width: 440px)': {
      display: 'none',
    },
  },
  toolbarOpen: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.75, 0.9, 0.35),
    paddingLeft: theme.spacing(0.25),
    '& .MuiIconButton-root': {
      width: 38,
      height: 38,
      color: theme.palette.common.white,
      borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
      background: 'linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.08) 100%)',
      border: '1px solid rgba(255,255,255,0.12)',
      boxShadow: '0 10px 18px rgba(9, 45, 67, 0.12)',
      '&:hover': {
        background: 'linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.1) 100%)',
        boxShadow: '0 12px 22px rgba(9, 45, 67, 0.14)',
        transform: 'translateY(-2px)',
      },
    },
  },
  toolbarClose: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(100% - 20px)',
    margin: theme.spacing(0.8, 1.25, 0.95),
    paddingBottom: theme.spacing(1.05),
    '& .MuiIconButton-label': {
      color: theme.palette.primary,
    },
    '& .MuiIconButton-root': {
      width: 52,
      height: 52,
      borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
      background: 'rgba(255,255,255,0.18)',
      border: '1px solid transparent',
      boxShadow: 'none',
      marginLeft: 0,
      '&:hover': {
        background: 'linear-gradient(180deg, rgba(250, 253, 255, 0.98) 0%, rgba(239, 247, 251, 0.96) 100%)',
        boxShadow: '0 12px 20px rgba(8, 41, 63, 0.1)',
        transform: 'translateY(-1px)',
        borderColor: 'rgba(37, 134, 188, 0.14)',
      },
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 1,
      background: 'linear-gradient(90deg, rgba(37, 134, 188, 0.03) 0%, rgba(37, 134, 188, 0.2) 16%, rgba(37, 134, 188, 0.2) 84%, rgba(37, 134, 188, 0.03) 100%)',
      boxShadow: '0 1px 0 rgba(255,255,255,0.78)',
    },
  },
  nested: {
    margin: theme.spacing(0.18, 0.95, 0.18, 6.15),
    paddingLeft: theme.spacing(0.95),
    paddingRight: theme.spacing(1.15),
    minHeight: 38,
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    border: '1px solid transparent',
    color: theme.palette.primary.main,
    transition: 'background 180ms ease, border-color 180ms ease, box-shadow 180ms ease, color 180ms ease, transform 180ms ease',
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.35,
      color: 'inherit',
    },
  },
  //Agregado para quitar el borde azul al drawer
  paperAnchorDockedLeft: {
    border: 'none',
  },
  username: {
    color: 'white',
    textAlign: 'center',
  },
  containerAvatar: {
    padding: theme.spacing(2, 0, 2, 0),
    backgroundColor: '#2c8bd3',
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  plan: {
    textAlign: 'center',
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    fontSize: '16px',
  },
  userMenu: {
    '& .MuiList-padding': {
      paddingTop: `0px !important`,
      borderStyle: 'solid',
      borderWidth: 'thin',
    },
    '& .MuiPaper-root': {
      top: `${theme.spacing(8)}px !important`,
    },
  },
  HamburgerMenuIcon: {
    zIndex: '1',
    position: 'absolute',
    left: '15px',
  },
  mobileDisable: {
    '@media (max-width: 920px)': {
      display: 'none',
    },
  },
  mobileDisableDashboard: {
    '@media (max-width: 1080px)': {
      display: 'none',
    },
  },
  navLink: {
    textDecoration: 'none',
    color: 'inherit',
  },
  menuItem: {
    margin: theme.spacing(0.45, 0.75),
    padding: theme.spacing(0.9, 1.15),
    minHeight: 54,
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    border: '1px solid transparent',
    transition: 'background 180ms ease, box-shadow 180ms ease, border-color 180ms ease, transform 180ms ease',
    '& .MuiListItemIcon-root': {
      minWidth: 42,
      width: 42,
      height: 42,
      marginRight: theme.spacing(1.05),
      borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 10px 18px rgba(7, 32, 49, 0.14)',
      transition: 'background 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
    },
    '& .MuiListItemText-primary': {
      fontSize: 17,
      fontWeight: 500,
      letterSpacing: -0.1,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.3rem',
    },
    '& > .MuiSvgIcon-root': {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1.05),
    },
  },
  menuItemActive: {},
  menuChevron: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1.2),
    color: 'inherit',
    opacity: 0.92,
    transition: 'transform 180ms ease',
  },
  menuChevronOpen: {
    transform: 'rotate(90deg)',
  },
  submenuWrap: {
    margin: theme.spacing(0.1, 0.55, 0.55),
    paddingBottom: theme.spacing(0.15),
  },
  subgroup: {
    margin: theme.spacing(0.55, 0.45, 0.35, 0.3),
    padding: '7.8px 10px 6px 21.2px',
    borderTop: '1px solid rgba(255,255,255,0.24)',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.03) 100%)',
    boxShadow: '0 10px 22px rgba(8, 36, 54, 0.12)',
  },
  subgroupHeader: {
    minHeight: 34,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.05, 0, 0.15, 0.05),
    color: 'rgba(255,255,255,0.96)',
  },
  subgroupLabel: {
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.25,
  },
  subgroupSpacer: {
    flex: 1,
  },
  subgroupIconButton: {
    padding: 4,
    color: 'rgba(255,255,255,0.96)',
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    '&:hover': {
      background: 'rgba(255,255,255,0.1)',
    },
  },
  subgroupActionButton: {
    width: 28,
    height: 28,
    marginRight: theme.spacing(0.7),
    background: 'linear-gradient(180deg, rgba(255,255,255,0.09) 0%, rgba(255,255,255,0.04) 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 6px 12px rgba(8, 36, 54, 0.08), inset 0 1px 0 rgba(255,255,255,0.05)',
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
    '&:hover': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.13) 0%, rgba(255,255,255,0.06) 100%)',
      boxShadow: '0 8px 14px rgba(8, 36, 54, 0.1), inset 0 1px 0 rgba(255,255,255,0.07)',
    },
  },
  subgroupToggleButton: {
    marginRight: theme.spacing(0.15),
  },
  subgroupDivider: {
    borderBottom: '1px solid rgba(255,255,255,0.2)',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.45),
  },
  bold: {
    fontWeight: 'bold',
  },
  wordCut: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  dashboardList: {
    ...scrollsSettings,
    width: '100%',
    margin: theme.spacing(0.15, 0, 0, 0),
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
    '&::-webkit-scrollbar': {
      ...webkitScrollbar
    },
    '&::-webkit-scrollbar-track': {
      ...webkitscrollbarTrack
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255,255,255,0.28)',
      borderRadius: 999,
    },
    '& $nested': {
      width: '100%',
      margin: theme.spacing(0.12, 0, 0.12, 0),
      paddingLeft: theme.spacing(1.15),
      paddingRight: theme.spacing(1.15),
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
    '& $nested .MuiListItemText-root': {
      margin: 0,
    },
    '& $nested .MuiListItemText-primary': {
      textAlign: 'left',
    },
  },
  logoImg: {
    '@media (max-width: 350px)': {
      display: 'none',
    },
  },
  customList: {
    height: '89%',
    paddingTop: 0,
    marginTop: 0,
  },
  containerPlanInfo: {
    position: 'absolute',
    right: '160px',
    top: '3px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  planInfo: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#E3F2FD",
    color: "#1565C0",
    padding: theme.spacing(0.5, 1),
    borderRadius: 50,
    overflow: "hidden",
    width: "fit-content",
    transition: "background-color 0.6s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#BBDEFB",
    },
  },
  planText: {
    marginLeft: theme.spacing(1),
    whiteSpace: "nowrap",
    transition: "opacity 0.4s ease, max-width 0.4s ease, margin 0.3s ease",
    opacity: 0,
    maxWidth: 0,
    overflow: "hidden",
    display: "inline-block",
    "&.visible": {
      opacity: 1,
      maxWidth: 200,
      marginRight: theme.spacing(0.5),
    },
  },
  addButton: {
    /* 🔥 COLOR BLANCO */
    color: '#fff',
  },
}));

const Drawer = ({ handleLogout, refresh }) => {
  const classes = useStyles();
  const theme = useTheme();
  const blueLine = blueBar()
  const { plan } = useContext(UserContext);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [openMenuAnalisis, setOpenMenuAnalisis] = useState(false);
  const [openMenuDashboard, setOpenMenuDashboard] = useState(false);
  const [openMenuDashboardCustom, setOpenMenuDashboardCustom] = useState(true);
  const [openMenuFacturacion, setOpenMenuFacturacion] = useState(false);
  const [show, setShow] = useState(false);
  const [dataDashboardDinamic, setDataDashboardDinamic] = useState([]);
  //Estado encargado de resetear la campanita de notificaciones.
  const [clean, setClean] = useState(true);
  let history = useHistory();
  const { isMobile } = useDeviceDetect(920);
  const [openMenuAlertsAndReports, setOpenMenuAlertsAndReports] = useState(false);
  const [openMenuControl, setOpenMenuAlertsControl] = useState(false);
  const [openMenuDiagramList, setOpenMenuDiagramList] = useState(false);

  useEffect(() => {
    onResize();
  }, [])

  //Carga los dashboard del usuario.
  useEffect(() => {
    const getDataDashboard = async () => {
      let res = await getDashboards()
      setDataDashboardDinamic(res.data);
    }
    if (plan) {
      getDataDashboard()
    }
    // eslint-disable-next-line
  }, [refresh]);

  //Identifico vista mobile o desktop para q la tabla muestre solo total.
  useEffect(() => {
    window.addEventListener('resize', onResize, { passive: true });
  });

  //Estado service worker
  useEffect(() => {
    if (plan?.info?.email) {
      subscription(plan, getTokenFromLocalStorage())
    }
    // eslint-disable-next-line
  }, [plan]);

  //Funcion para identificar vista mobile.
  const onResize = () => {
    if (document.body.clientWidth <= 920) {
      setShow(false);
    }
    else {
      setShow(true);
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    //mobile
    setShow(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    if (isMobile) {
      //mobile
      setShow(false);
    }
    //Comprimo los menus de sub-opciones
    setOpenMenuDashboard(false);
    setOpenMenuAnalisis(false);
    setOpenMenuFacturacion(false);
    setOpenMenuAlertsAndReports(false);
    setOpenMenuAlertsControl(false)
    setOpenMenuDiagramList(false)
  };

  const handleOpenMenuDashboard = () => {
    //Abro el drawer
    setOpen(true);
    //Comprimo/expando sub-opciones
    setOpenMenuDashboard(!openMenuDashboard);
  };

  const handleOpenMenuDashboardCustom = () => {
    setOpenMenuDashboardCustom(!openMenuDashboardCustom);
  }

  const handleOpenMenuAnalisis = () => {
    //Abro el drawer
    setOpen(true);
    //Comprimo/expando sub-opciones
    setOpenMenuAnalisis(!openMenuAnalisis);
  };

  const handleOpenMenuFacturacion = () => {
    //Abro el drawer
    setOpen(true);
    //Comprimo/expando sub-opciones
    setOpenMenuFacturacion(!openMenuFacturacion);
  };

  const handleOpenMenuAlertsAndReports = () => {
    //Abro el drawer
    setOpen(true);
    //Comprimo/expando sub-opciones
    setOpenMenuAlertsAndReports(!openMenuAlertsAndReports);
  };

  const handleOpenMenuControl = () => {
    //Abro el drawer
    setOpen(true);
    //Comprimo/expando sub-opciones
    setOpenMenuAlertsControl(!openMenuControl);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setClean(false)
    setAnchorEl(null);
  };

  const disabledTextLink = variation => {
    if (variation === false) {
      return { pointerEvents: 'none', cursor: 'not-allowed' };
    } else {
      return {};
    }
  };

  const pathname = location.pathname || '/';
  const isPathMatch = routes => routes.some(route => pathname === route || pathname.startsWith(`${route}/`));
  const isHomeActive = pathname === '/';
  const isDashboardActive = isPathMatch([
    '/resumen',
    '/estado',
    '/resumen_general',
    '/resumen_localizacion',
    '/mapa',
    '/ecologico',
    '/solar',
    '/crear-personalizado',
    '/personalizado',
  ]);
  const isFacturacionActive = isPathMatch([
    '/calculador',
    '/factura',
    '/conciliacion',
    '/sub_factura',
  ]);
  const isAnalisisActive = isPathMatch([
    '/instantaneos',
    '/instantaneos_avanzado',
    '/historicos',
    '/historicos_avanzado',
    '/calidad',
    '/heatmap',
  ]);
  const isAlertsActive = isPathMatch([
    '/informes',
    '/eventos',
    '/alarmas-en-dispositivos',
    '/alerts',
  ]);
  const isControlActive = isPathMatch([
    '/diagram_list',
    '/plc_list',
    '/control',
    '/diagramas',
  ]);

  return (
    <>
      {plan && (
        <div
          className={clsx(classes.root, {
            [classes.modalOverlay]: open,
          })}
        >
          <AppBar
            style={{ backgroundColor: '#FFF' }}
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            {/* Icon Hamburger Menu */}
            {!show && isMobile && (
              <div className={classes.HamburgerMenuIcon}>
                <IconButton
                  color="primary"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </div>
            )}

            <Toolbar variant="dense" className={classes.toolbar1}>
              <div className={classes.topActions}>
                {/* CHIP */}
                <ContainerChips plan={plan} isMobile={isMobile} className={classes.paymentsButtonSquare} />

                {/* NOTFICACIONES */}
                {
                  plan?.info &&
                  < NotificationIconComponent clean={clean} handleLogout={handleLogout} />
                }

                {/* CONFIGURACION */}
                <Tooltip title="Configuración">
                  <NavLink className={classes.headerIconLink} to={`/configuracion`}>
                    <IconButton color="primary" aria-label="Configuración">
                      <SettingsOutlinedIcon />
                    </IconButton>
                  </NavLink>
                </Tooltip>

                {/* SOPORTE */}
                <Tooltip title="Soporte">
                  <IconButton
                    color="primary"
                    aria-label="Ayuda"
                    onClick={() => history.push('/ayuda')}
                  >
                    <HelpOutlineOutlinedIcon />
                  </IconButton>
                </Tooltip>

                {/* lOGIN*/}
                {!getTokenFromLocalStorage() ? (
                  <Tooltip title="Iniciar Sesión">
                    <IconButton
                      className={classes.topIcon}
                      color="primary"
                      aria-label="Iniciar Sesión"
                      onClick={() => history.push('/login')}
                    >
                      <AccountCircleOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <>
                    <Tooltip title={plan?.info?.username || 'User'}>
                      <IconButton
                        color="primary"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <AccountCircleOutlinedIcon />
                      </IconButton>
                    </Tooltip>

                    {/* Menu avatar */}
                    <Menu
                      className={classes.userMenu}
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <Box className={classes.containerAvatar} width={'100%'} minWidth={'250px'} >
                        <Box width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                          {/* <Avatar className={classes.avatar} src="/broken-image.jpg" /> */}
                          <img src={logoAvatar} style={{ width: '60px' }} alt="Logo" />
                        </Box>
                        <Box mr={1} mt={1} fontSize={18} className={classes.username}>
                          @{plan?.info?.username}
                        </Box>
                        <Box fontWeight={100} p={1} fontSize={15} className={classes.username}>
                          {plan?.info?.email}
                        </Box>
                      </Box>

                      {plan.access?.pagos ? <NavLink className={classes.navLink}
                        to={`/pagos`}>
                        <Tooltip title="Gestión de Plan">
                          <Box
                            onClick={() => {
                              handleClose();
                            }} mt={1} className={classes.plan}>
                            Plan {plan?.info?.plan}
                          </Box>
                        </Tooltip>
                      </NavLink> :
                        <Tooltip title="Gestión de Plan">
                          <Box
                            onClick={() => {
                              handleClose();
                            }} mt={1} className={classes.plan}>
                            Plan {plan?.info?.plan}
                          </Box>
                        </Tooltip>
                      }

                      <Box mt={1} width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                        <Box style={{ padding: '5px 8px 5px 8px' }} width={'100%'} >
                          <Button
                            onClick={() => {
                              handleClose();
                              history.push(`/configuracion-cuenta`);
                            }}
                            fullWidth size="small" variant="contained" color="primary" >
                            Configuración Cuenta
                          </Button>
                        </Box>
                        <Box style={{ padding: '2px 8px 5px 8px' }} width={'100%'} >
                          <Button
                            onClick={() => {
                              handleLogout();
                              handleClose();
                            }}
                            fullWidth size="small" variant="contained" color="primary" >
                            Cerrar Sesión
                          </Button>
                        </Box>
                      </Box>

                      {blueLine}

                      <Box p={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                        <img
                          src="/images/logo.svg"
                          alt="logo"
                          style={{ height: '20px' }}
                        />
                      </Box>
                    </Menu>
                  </>
                )}
              </div>

              <img
                className={classes.logoImg}
                src="/images/logo.svg"
                alt="logo"
                className={`${classes.logoImg} ${classes.headerLogo}`}
              />
            </Toolbar>
          </AppBar>

          {show && (
            <div>
              <ClickAwayListener onClickAway={handleDrawerClose}>
                <MUIDrawer
                  variant="permanent"
                  className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                  })}
                  classes={{
                    paper: clsx({
                      [classes.drawerOpen]: open,
                      [classes.drawerClose]: !open,
                    }),
                    paperAnchorDockedLeft: classes.paperAnchorDockedLeft,
                  }}
                >
                  {open ? (
                    <div className={classes.toolbarOpen}>
                      <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? (
                          <ChevronRightIcon />
                        ) : (
                          <ChevronLeftIcon />
                        )}
                      </IconButton>
                    </div>
                  ) : (
                    <div className={classes.toolbarClose}>
                      <IconButton
                        color="primary"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={classes.menuButton}
                      >
                        <MenuIcon />
                      </IconButton>
                    </div>
                  )}

                  <List
                    className={classes.customList}
                    disablePadding={true}
                  >
                    <Box display={'flex'} height={'100%'} flexDirection='column' >
                      <Box >
                        {/* Inicio*/}
                        <NavLink
                          className={classes.navLink}
                          exact
                          to={`/`}
                        >
                          <ListItem
                            button
                            className={clsx(classes.menuItem, {
                              [classes.menuItemActive]: isHomeActive,
                            })}
                            onClick={() => {
                              handleDrawerClose();
                            }}
                          >
                            <Tooltip title="Inicio" arrow>
                              <ListItemIcon>
                                <HomeIcon />
                              </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary="Inicio" />
                          </ListItem>
                        </NavLink>

                        {/*Dashboards*/}
                        <ListItem
                          button
                          className={clsx(classes.menuItem, {
                            [classes.menuItemActive]: isDashboardActive,
                          })}
                          onClick={handleOpenMenuDashboard}
                          disabled={!plan?.access}
                        >
                          <Tooltip title="Dashboards" arrow>
                            <ListItemIcon>
                              <DashboardIcon />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary="Dashboards" />
                          <ChevronRightIcon className={clsx(classes.menuChevron, {
                            [classes.menuChevronOpen]: openMenuDashboard,
                          })} />
                        </ListItem>

                        <Collapse
                          in={openMenuDashboard}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List component="div" disablePadding className={classes.submenuWrap}>

                            {/*Resumen dispositivo*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/resumen`}
                              style={disabledTextLink(
                                plan?.access?.dashboards_resumen
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboards_resumen}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Resumen dispositivo" />
                              </ListItem>
                            </NavLink>

                            {/*Estado*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/estado`}
                              style={disabledTextLink(
                                plan?.access?.dashboards_estado
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboards_estado}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Estado" />
                              </ListItem>
                            </NavLink>

                            {/*Resumen general*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/resumen_general`}
                              style={disabledTextLink(
                                plan?.access?.dashboard_empresa
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboard_empresa}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Resumen general" />
                              </ListItem>
                            </NavLink>

                            {/*Resumen localización*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/resumen_localizacion`}
                              style={disabledTextLink(
                                plan?.access?.dashboard_localizacion
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboard_localizacion}
                                dense
                                button
                                className={clsx(classes.nested)}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Resumen localización" />
                              </ListItem>
                            </NavLink>

                            {/*Mapa*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/mapa`}
                              style={disabledTextLink(
                                plan?.access?.dashboards_mapa
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboards_mapa}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Mapa" />
                              </ListItem>
                            </NavLink>

                            {/*Ecoloico*/}
                            <NavLink
                              className={classes.navLink}
                              to={`${`/ecologico`}`}
                              style={disabledTextLink(plan?.access?.dashboard_ecologico)}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboard_ecologico}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Ecológico" />
                              </ListItem>
                            </NavLink>

                            {/* Solar */}
                            <NavLink
                              className={classes.navLink}
                              to={`${`/solar`}`}
                              style={disabledTextLink(plan?.access?.dashboard_solar)}
                            >
                              <ListItem
                                disabled={!plan?.access?.dashboard_solar}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Solar" />
                              </ListItem>
                            </NavLink>

                            {plan?.access?.dashboards_creacion &&
                              <>
                                <Box className={classes.subgroup}>
                                  <Box className={classes.subgroupHeader}>
                                    <Box className={classes.subgroupLabel}>Personalizados</Box>
                                    <Box className={classes.subgroupSpacer} />
                                    <Tooltip title="Crear nuevo Dashboard Personalizado">
                                      <IconButton
                                        size="small"
                                        className={clsx(
                                          classes.subgroupIconButton,
                                          classes.subgroupActionButton,
                                          classes.addButton
                                        )}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          history.push(`/crear-personalizado`);
                                          handleDrawerClose();
                                        }}
                                      >
                                        <AddIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <IconButton
                                      size="small"
                                      className={clsx(classes.subgroupIconButton, classes.subgroupToggleButton)}
                                      onClick={handleOpenMenuDashboardCustom}
                                    >
                                      <ChevronRightIcon className={clsx(classes.menuChevron, {
                                        [classes.menuChevronOpen]: openMenuDashboardCustom,
                                      })} />
                                    </IconButton>
                                  </Box>
                                  <Box className={classes.subgroupDivider} />

                                  <Collapse
                                    in={openMenuDashboardCustom}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    {/*Dashboards creados lista*/}
                                    <Box className={classes.dashboardList}>

                                      {dataDashboardDinamic?.map((element, index) => {
                                        return (
                                          <Tooltip key={index} title={element?.name}>
                                            <NavLink
                                              className={classes.navLink}
                                              to={`/personalizado/${element?.id}`}
                                              style={disabledTextLink(
                                                plan?.access?.dashboards_creacion
                                              )}
                                            >
                                              <ListItem
                                                disabled={!plan?.access?.dashboards_creacion}
                                                dense
                                                button
                                                className={clsx(
                                                  classes.nested
                                                )}
                                                onClick={() => {
                                                  handleDrawerClose();
                                                }}
                                              >
                                                <ListItemText
                                                  primary={
                                                    <div className={classes.wordCut}>
                                                      {element?.name}
                                                    </div>
                                                  }
                                                />
                                              </ListItem>
                                            </NavLink>
                                          </Tooltip>
                                        );
                                      }
                                      )}
                                    </Box>
                                  </Collapse>
                                </Box>
                              </>
                            }
                          </List>
                        </Collapse>

                        {/*Auditor*/}
                        {/* <NavLink
                          className={classes.navLink}
                          to={`.${`/auditor`}`}
                          style={disabledTextLink(plan?.access?.auditor)}
                        >
                          <ListItem
                            disabled={!plan?.access?.auditor}
                            button
                            onClick={() => {
                              handleDrawerClose();
                            }}
                          >
                            <Tooltip title="Auditor" arrow>
                              <ListItemIcon>
                                <AuditorIcon />
                              </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary="Auditor" />
                          </ListItem>
                        </NavLink> */}

                        {/*Facturación*/}
                        <ListItem
                          disabled={!plan?.access}
                          button
                          className={clsx(classes.menuItem, {
                            [classes.menuItemActive]: isFacturacionActive,
                          })}
                          onClick={handleOpenMenuFacturacion}
                        >
                          <Tooltip title="Facturación" arrow>
                            <ListItemIcon>
                              <LocalAtmIcon />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary="Facturación" />
                          <ChevronRightIcon className={clsx(classes.menuChevron, {
                            [classes.menuChevronOpen]: openMenuFacturacion,
                          })} />
                        </ListItem>

                        {/*Factura*/}
                        <Collapse
                          in={openMenuFacturacion}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>

                            {/*Calculador simple*/}
                            {plan?.access?.facturacion_factura_free && (
                              <NavLink
                                className={classes.navLink}
                                to={`/calculador`}
                                style={disabledTextLink(
                                  plan?.access?.facturacion_factura_free
                                )}
                              >
                                <ListItem
                                  disabled={false}
                                  dense
                                  button
                                  className={classes.nested}
                                  onClick={() => {
                                    handleDrawerClose();
                                  }}
                                >
                                  <ListItemText primary="Calculador simple" />
                                </ListItem>
                              </NavLink>
                            )}

                            <NavLink
                              className={classes.navLink}
                              to={`/facturas`}
                            >
                              <ListItem
                                disabled={false}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Gestión de facturas" />
                              </ListItem>
                            </NavLink>

                            <NavLink
                              className={classes.navLink}
                              to={`/gestiones`}
                            >
                              <ListItem
                                disabled={false}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Gestiones" />
                              </ListItem>
                            </NavLink>

                            {/* <NavLink
                              className={classes.navLink}
                              to={`/factura`}
                              style={disabledTextLink(
                                plan?.access?.facturacion_factura
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.facturacion_factura}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Factura" />
                              </ListItem>
                            </NavLink> */}

                            {/*Conciliación*/}
                            {/* <NavLink
                              className={classes.navLink}
                              to={`/conciliacion`}
                              style={disabledTextLink(
                                plan?.access?.facturacion_conciliacion
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.facturacion_conciliacion}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Conciliación" />
                              </ListItem>
                            </NavLink> */}

                            {/*Subdivisión*/}
                            {/* <NavLink
                              className={classes.navLink}
                              to={`/sub_factura`}
                              style={disabledTextLink(
                                plan?.access?.facturacion_subdivision
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.facturacion_subdivision}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Subfactura" />
                              </ListItem>
                            </NavLink> */}

                            <NavLink
                              className={classes.navLink}
                              to={`/billing-consumptions`}
                              style={disabledTextLink(!!plan?.access)}
                            >
                              <ListItem
                                disabled={!plan?.access}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Consumos históricos" />
                              </ListItem>
                            </NavLink>
                          </List>
                        </Collapse>

                        {/*Analisis*/}
                        <ListItem
                          button
                          className={clsx(classes.menuItem, {
                            [classes.menuItemActive]: isAnalisisActive,
                          })}
                          onClick={handleOpenMenuAnalisis}
                          disabled={!plan?.access}
                        >
                          <Tooltip title="Analisis" arrow>
                            <ListItemIcon>
                              <TimelineIcon />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary="Análisis" />
                          <ChevronRightIcon className={clsx(classes.menuChevron, {
                            [classes.menuChevronOpen]: openMenuAnalisis,
                          })} />
                        </ListItem>

                        {/*Instantáneos*/}
                        <Collapse
                          in={openMenuAnalisis}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>
                            <NavLink
                              className={classes.navLink}
                              to={`/instantaneos`}
                              style={disabledTextLink(
                                plan?.access?.analisis_instantaneos
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_instantaneos}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Instantáneos" />
                              </ListItem>
                            </NavLink>

                            {/*Instantáneos avanzados*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/instantaneos_avanzado`}
                              style={disabledTextLink(
                                plan?.access?.analisis_instantaneos_avanzado
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_instantaneos_avanzado}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Instantáneos avanzado" />
                              </ListItem>
                            </NavLink>

                            {/*Históricos*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/historicos`}
                              style={disabledTextLink(
                                plan?.access?.analisis_historicos
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_historicos}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Históricos" />
                              </ListItem>
                            </NavLink>

                            {/*Históricos avanzado*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/historicos_avanzado`}
                              style={disabledTextLink(
                                plan?.access?.analisis_historicos_avanzado
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_historicos_avanzado}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Históricos avanzado" />
                              </ListItem>
                            </NavLink>

                            {/*Calidad*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/calidad`}
                              style={disabledTextLink(
                                plan?.access?.analisis_calidad
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_calidad}
                                dense
                                button
                                className={clsx(
                                  classes.mobileDisable,
                                  classes.nested
                                )}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Calidad" />
                              </ListItem>
                            </NavLink>

                            {/* Heatmap*/}
                            < NavLink
                              className={classes.navLink}
                              to={`/heatmap`}
                              style={disabledTextLink(
                                plan?.access?.analisis_heatmap
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.analisis_heatmap}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Heatmap" />
                              </ListItem>
                            </NavLink>

                          </List>
                        </Collapse>

                        {/* Alertas y Reportes */}
                        <ListItem
                          button
                          className={clsx(classes.menuItem, {
                            [classes.menuItemActive]: isAlertsActive,
                          })}
                          onClick={handleOpenMenuAlertsAndReports}
                          disabled={!plan?.access?.alertas_y_reportes}>
                          <Tooltip title="Alertas y reportes" arrow>
                            <ListItemIcon>
                              <DescriptionIcon />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary="Alertas y reportes" />
                          <ChevronRightIcon className={clsx(classes.menuChevron, {
                            [classes.menuChevronOpen]: openMenuAlertsAndReports,
                          })} />
                        </ListItem>

                        {/*Informes*/}
                        <Collapse
                          in={openMenuAlertsAndReports}
                          timeout="auto"
                          unmountOnExit>
                          <List component="div" disablePadding>
                            <NavLink
                              className={classes.navLink}
                              to={`/informes`}
                              style={disabledTextLink(
                                plan?.access?.alertas_y_reportes_informes
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.alertas_y_reportes_informes}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Reportes" />
                              </ListItem>
                            </NavLink>

                            {/*Eventos*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/eventos`}
                              style={disabledTextLink(
                                plan?.access?.alertas_y_reportes_eventos
                              )}
                            >
                              <ListItem
                                disabled={!plan?.access?.alertas_y_reportes_eventos}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}
                              >
                                <ListItemText primary="Eventos" />
                              </ListItem>
                            </NavLink>

                            {/*Alarmas en dispositivos*/}
                            <NavLink
                              className={classes.navLink}
                              to={`/alarmas-en-dispositivos`}
                              style={disabledTextLink(
                                plan?.access?.alertas_y_reportes_alarmas
                              )}>
                              <ListItem
                                disabled={!plan?.access?.alertas_y_reportes_alarmas}
                                dense
                                button
                                className={classes.nested}
                                onClick={() => {
                                  handleDrawerClose();
                                }}>
                                <ListItemText primary="Alarmas en dispositivos" />
                              </ListItem>
                            </NavLink>

                            {/*Diagrama Alertas y reportes*/}
                            {
                              <NavLink
                                className={classes.navLink}
                                to={`/alerts`}
                                style={disabledTextLink(plan?.access?.alertas_y_reportes_alertas)}
                              >
                                <ListItem
                                  disabled={!plan?.access?.alertas_y_reportes_alertas}
                                  dense
                                  button
                                  className={classes.nested}
                                  onClick={() => {
                                    handleDrawerClose();
                                  }}
                                >
                                  <ListItemText primary="Alertas" />
                                </ListItem>
                              </NavLink>
                            }
                          </List>
                        </Collapse>

                        {/* Control */}
                        <ListItem
                          button
                          className={clsx(classes.menuItem, {
                            [classes.menuItemActive]: isControlActive,
                          })}
                          onClick={handleOpenMenuControl}
                        // disabled={!plan?.access?.control}
                        >
                          <Tooltip title="Control" arrow>
                            <ListItemIcon>
                              <ControlIcon />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary="Control" />
                          <ChevronRightIcon className={clsx(classes.menuChevron, {
                            [classes.menuChevronOpen]: openMenuControl,
                          })} />
                        </ListItem>

                        <Collapse
                          in={openMenuControl}
                          timeout="auto"
                          unmountOnExit>
                          <List component="div" disablePadding>
                            {/*Automate*/}
                            {/* {
                              <NavLink
                                className={classes.navLink}
                                to={`/plc_list`}
                                style={disabledTextLink(plan?.access?.control_automate)}
                              >
                                <ListItem
                                  disabled={!plan?.access?.control_automate}
                                  dense
                                  button
                                  className={classes.nested}
                                  onClick={() => {
                                    handleDrawerClose();
                                  }}
                                >
                                  <ListItemText primary="Automate" />
                                </ListItem>
                              </NavLink>
                            } */}
                          </List>
                          <List component="div" disablePadding>
                            {/*Diagramas*/}
                            {
                              <NavLink
                                className={classes.navLink}
                                to={`/diagram_list`}
                                style={disabledTextLink(true)}
                              >
                                <ListItem
                                  disabled={!true}
                                  dense
                                  button
                                  className={classes.nested}
                                  onClick={() => {
                                    handleDrawerClose();
                                  }}
                                >
                                  <ListItemText primary="Diagramas" />
                                </ListItem>
                              </NavLink>
                            }
                          </List>
                        </Collapse>
                        <Collapse
                          in={openMenuDiagramList}
                          timeout="auto"
                          unmountOnExit>
                        </Collapse>
                      </Box>

                      {/* Assistant */}
                      {/* <Box
                        onClick={handleDrawerClose}
                        style={{
                          marginTop: '2px',
                          borderTop: `solid 1px ${open ? 'white' : '#2586bc'}`,
                          paddingTop: '5px',
                          // borderBottom: `solid 1px ${open ? 'white' : '#2586bc'}`,
                        }}
                      >
                        <NavLink
                          className={classes.navLink}
                          to={`.${`/assistant`}`}
                          style={disabledTextLink(true)}
                        >
                          <ListItem
                            button
                            disabled={false}
                          >
                            <Tooltip title="Assistant" arrow>
                              <ListItemIcon>
                                <Box >
                                  <img src={open ? logoAssistantWhite : logoAssistantBlue} style={{ width: '29px' }} alt="Logo" />
                                </Box>
                              </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary="Assistant" />
                          </ListItem>
                        </NavLink>
                      </Box> */}

                    </Box>

                  </List>
                </MUIDrawer>
              </ClickAwayListener>
            </div >
          )}
        </div >
      )}
    </>
  );
};

export default Drawer;


